import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { GUIDHelpers } from '../../shared/utilities/developHelpers';
import { ReplaySubject, Subscription } from 'rxjs';
import { ImagesToTree, TreeImageCategory, ImageInfo } from '../image-viewer/imageHelper';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.css']
})
export class ImageModalComponent implements OnInit, OnDestroy {
  @Input('options') data: ImageViewerInputData;
  @Input() selection: Array<string> = [];
  @Input('images') images : Array<ImageInfo>;
  @Input('id') modalId: string = '';
  @Input('hideList') hiddenList = false; // only used in requisitions at the moment
  @Input() folders = false;
  @Input() draggable = false;
  @Input() message;
  @Output() selectionChange = new EventEmitter<Array<string>>();
  @Output() deleteFile = new EventEmitter<string>();
  @Output() currentPath = new EventEmitter<string>();
  @Output() bubble = new EventEmitter<any>();
  index = 0;
  rotate = 0;
  isOpen = false;
  currentPdf;
  currentUser = localStorage.getItem('bearer'); // used in img links for rights purposes

  clicker = new SingleOrDoubleClick();
  preventSingle = false;
  timer;
  folderArray = [];
  help = new GUIDHelpers();
  branchedImages = new ImagesToTree();
  currentPathSubscription: Subscription;
  folderReorderSubscription: Subscription;
  messengerServiceSubscription: Subscription;
  draggingImage: string;
  isAdmin: boolean = false;

  constructor(private sanitizer: DomSanitizer, private http: HttpClient) {
    
  }

  ngOnInit() {
    this.isAdmin = JSON.parse(localStorage.getItem('guards') as string).find(x => x.name == 'SettingsAccess') == null ? false : true;
    this.currentPathSubscription = this.branchedImages.emitFolderPath().subscribe(
      (data) => { this.currentPath.emit(data) }
    );
    this.folderReorderSubscription = this.branchedImages.folderReorder().subscribe(
      (data) => { if (data != null) { this.batchRenameFiles(data.object, data.path); console.log(data) } }
    )
    this.messengerServiceSubscription = this.branchedImages.messenger().subscribe(
      (data) => {
        if (data != null) {
          switch (data.type) {
            case ('dropImg'): {
              this.editFilePaths([{ fileId: data.id }], data.folder.folderPath);
              break
            }
          }
        }
      }
    )
  }

  ngOnChanges(x) {
    if (!!x.images && !!x.images.currentValue && this.folders) {
      this.branchedImages.createFolders(this.images);
    }
    if (!!x.message && !!x.message.currentValue && x.message.currentValue != x.message.previousValue) { console.log(x) }
    
  }

  ngOnDestroy() {
    this.currentPathSubscription.unsubscribe();
    this.folderReorderSubscription.unsubscribe();
    this.messengerServiceSubscription.unsubscribe();
  }

  getURL(id) {
    return api.jubloApi + 'api/shared/attachments/' + id + '?userId=' + localStorage.getItem('bearer');
  }

  checkIfValidDocument(ext) {
    if (['.text', '.css', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pages', '.ai', '.psd', '.tiff', '.svg', '.eps', '.zip', '.rar'].includes(ext.toLowerCase())) { return true }
    else { return false }
  }

  checkIfValidImage(ext) {
    if (['.png', '.jpg', '.jpeg'].includes(ext.toLowerCase())) { return true }
    else { return false }
  }

  async openImageInModal(image, index) {
    this.preventSingle = true;
    clearTimeout(this.timer);
    this.currentPdf = null;
    this.opener();
    if (image.extension == '.pdf') {
      this.currentPdf = fetch(this.getURL(this.images[index].fileId)).then(res => res.blob()).then(blob => {
        this.currentPdf = URL.createObjectURL(blob)
        this.isOpen = true;
      })
    }
    this.index = index;
  }

  test() {
    console.log('test fired!')
  }

  async delayedSelection(image,index) {
    if (!!this.data && this.data.useSelection) {
      this.preventSingle = false;
      this.timer = setTimeout(() => {
        if (!this.preventSingle) { this.addToSelection(image.fileId) }
      }, 400)
    }
    else {
      this.openImageInModal(image, index);
    }
  }

  closer() {
    document.getElementById('imageView' + this.modalId).click();
    this.isOpen = false;
  }

  opener() {
    document.getElementById('imageView' + this.modalId + 'Activator').click();
  }

  addToSelection(id: string) {
    if (this.selection.includes(id)) {
      let i = this.selection.indexOf(id);
      this.selection.splice(i, 1);
      this.selectionChange.emit(this.selection);
    }
    else {
      this.selection.push(id);
      this.selectionChange.emit(this.selection);
    }
    console.log(this.selection)
  }

  itemToDelete(id) {
    this.deleteFile.emit(id);
  }

  async createFolderView() {
    let tempFolders = [];
    let ids = {};
    for (let x of Array.from( new Set( this.images.map(x => { return x.path }) ) )) {
      if (x != null) {
        let path = x.split('/');
        for (var i = 0; i < path.length; i++) {
          if (!ids[path.slice(0, i + 1).join('/')]) { ids[path.slice(0, i + 1).join('/')] = this.help.newGUID() }
          tempFolders.push({ name: path[i], id: ids[path.slice(0, i+1).join('/')], parentId: i > 0 ? ids[path.slice(0, i).join('/')]: null});
        }
      }
    }
    for (let x of this.images) {
      x['parentId'] = ids[x.path]
    }
    console.log(tempFolders, this.images);
  }

  renameFolder() {
    if (this.branchedImages.viewFolder.name.trim() != '' && this.branchedImages.viewFolder.name.split('/').join('').trim() != '') {
      this.branchedImages.viewFolder.name = this.branchedImages.viewFolder.name.split('/').join('').trim();
      let pathArray: Array<string> = this.branchedImages.viewFolder.folderPath.split('/');
      pathArray = pathArray.length != 1 ? pathArray.slice(0, pathArray.length - 1) : [];
      pathArray.push(this.branchedImages.viewFolder.name);
      this.branchedImages.viewFolder.folderPath = pathArray.join('/');
      this.branchedImages.selectedFolderPath.next(this.branchedImages.viewFolder.folderPath);
      if (this.branchedImages.viewFolder.children.length > 0) {
        for (let x of this.branchedImages.viewFolder.children) {
          this.batchRenameFiles(x, this.branchedImages.viewFolder.folderPath);
        }
        
      }
      if (this.branchedImages.viewFolder.items.length > 0) {
        this.editFilePaths(this.branchedImages.viewFolder.items, this.branchedImages.viewFolder.folderPath)
      }
    }
    else {
      this.branchedImages.viewFolder.name = this.branchedImages.viewFolder.originalData.name
    }
    console.log(this.branchedImages.viewFolder)
  }

  batchRenameFiles(cat: TreeImageCategory, parentFolderPath: string) {
    cat.folderPath = parentFolderPath != '' ? parentFolderPath + '/' + cat.name : cat.name;
    if (cat.items.length > 0) { this.editFilePaths(cat.items, cat.folderPath) }
    if (cat.children.length > 0) {
      for (let x of cat.children) {
        this.batchRenameFiles(x, cat.folderPath)
      }
    }
    
  }

  editFilePaths(fileArray, newPath) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    for (let x of fileArray) {
      x.path = newPath;
      this.images.find(y => y.fileId == x.fileId).path = newPath;
      this.http.put(api.jubloApi + 'api/shared/Attachments/EditFilePath', {
        fileId: x.fileId,
        path: newPath
      }, { headers }).subscribe(
        (data) => { },
        (response) => { console.log('Error', x, newPath, response) },
        () => { this.branchedImages.createFolders(this.images) }
      )
    }
    
  }

  addFolder() {
    let newFolderId = this.branchedImages.help.newGUID();
    let foldPath = this.branchedImages.viewFolder.folderPath != '' ? this.branchedImages.viewFolder.folderPath + '/New' : 'New';
    let fold = {
      name: 'New',
      id: newFolderId,
      showChildren: false,
      children: [],
      items: [],
      originalData: { name: 'New', id: newFolderId, parentId: this.branchedImages.viewFolder.id, folderPath: foldPath },
      parentId: this.branchedImages.viewFolder.id,
      folderPath: foldPath,
      right: this.branchedImages.viewFolder.right
    }
    this.branchedImages.viewFolder.children.push(fold);
    this.branchedImages.viewFolder.children = this.branchedImages.viewFolder.children.sort((a, b) => { return a.name > b.name ? 1 : -1 })
    this.branchedImages.folders.push(fold);
    this.branchedImages.pathToId[foldPath] = newFolderId;
  }

  onDrag(event) {
    this.bubble.emit({
      type: 'imgDrag',
      id: event.path[0].id
    })
    //console.log(event)
  }

  bubbleCatcher(event) {
    if (event.type) {
      switch (event.type) {
        case ('imgDrag'): {
          this.branchedImages.draggedImage = event.id;
          break
        }
      }
    }
    //console.log('sending event', event)
  }

  isOtherFileType(ext) {
    if (!['.png', '.jpg', '.jpeg', '.pdf','.msg'].includes(ext)) { return true }
    return false
  }

  officeFileType(ext) {
    if (['.xls', '.xlsx', '.pptx', '.ppt', '.doc', '.docx'].includes(ext)) { return true }
    return false
  }

  unsupportedFileType(ext) {
    if (['.png', '.jpg', '.jpeg', '.heic', '.pdf', '.txt', '.xls','.xlsx', '.pptx', '.doc', '.docx','.msg'].includes(ext)) { return false }
    return true
  }

}

export class ImageViewerInputData {
  useSelection?= false;
  canBeDeleted? = false;
}

export class SingleOrDoubleClick {
  delay: number = 500;
  timer;
  preventSingle = false;
  singleClick(): boolean {
    this.timer = () => {
      setTimeout(() => {
        if (!this.preventSingle) { return true; }
        else { return false }
      }, this.delay)
    }
    return this.timer
  }
  doubleClick() {
    this.preventSingle = true;
    clearTimeout(this.timer);
  }
}


interface SelectedCategory {
  id: string,
  name: string,
  originalName: string
}

interface ReorderFolderObject {
  path: string;
  object: TreeImageCategory;
}

interface MessageFormat {
  type: string;
  id: string;
  folder?: TreeImageCategory;
}
